import { DefaultFeaturedImg } from '@src/global/defaultFeaturedImage';

const imageOrDefault = (image) => image || DefaultFeaturedImg;

export {
    imageOrDefault,
};
